import React from "react";
import { useLocation } from "react-router";
const Error = () => {
  let location = useLocation();

  return <div>ERRORE{location.pathname}</div>;
};

export default Error;
